/*
===============================================

 Util

===============================================
*/
export default class Util{

	static clamp( value , inputMin , inputMax , outputMin , outputMax , clamp=true){
		let outVal = ((((value - inputMin) / (inputMax - inputMin)) * (outputMax - outputMin)) + outputMin);
		if (clamp) {
			if (outputMax < outputMin) {
				if (outVal < outputMax) {
					outVal = outputMax;
				} else if (outVal > outputMin) {
					outVal = outputMin;
				}
			} else {
				if (outVal > outputMax) {
					outVal = outputMax;
				} else if (outVal < outputMin) {
					outVal = outputMin;
				}
			}
		}
		return outVal;
	}

	static getUrlVars(value){
		const vars = {};
		let max = 0;
		let hash = "";
		let array = "";
		const url = window.location.search;
		hash  = url.slice(1).split('&');
		if (hash[0] === "") {
			return vars;
		}
		max = hash.length;
		for (let i = 0, end = max, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
			array = hash[i].split('=');
			//vars.push(array[0])
			vars[array[0]] = array[1];
		}
		if (value) {
			return vars[value];
		} else {
			return vars;
		}
	}

	static getHashValue(){
		const {
            hash
        } = window.location;
		return hash.replace('#','');
	}

	static shuffle(array){
		let m = array.length;
		t;
		i;
		while (m) {
			var i = Math.floor(Math.random() * m--);
			var t = array[m];
			array[m] = array[i];
			array[i] = t;
		}
		return array;
	}

	static round(value, digits=0){
		value = value * Math.pow(10, digits);
    value = Math.round(value);
		value = value / Math.pow(10, digits);
		return value
	}

	static addZeroLeft(value, digits=2){
		let zero = ''
		for(let i=0;i<=digits;i++){
			zero += '0'
		}
		let str = zero + value
		return str.substr(-2)
	}


	static getDayJp(value){
		if(value && typeof value === 'object'){
			let day = ''
			switch(value.getDay()){
				case 0:
					day = '日'
					break
				case 1:
					day = '月'
					break
				case 2:
					day = '火'
					break
				case 3:
					day = '水'
					break
				case 4:
					day = '木'
					break
				case 5:
					day = '金'
					break
				case 6:
					day = '土'
					break
			}
			return day
		}
		return ''
	}


	/**
	 * H(0〜1)、S(0-1)、L(0-1)を指定して、0〜255のRGB値を取得します。
	 * @param {Number} h - 色相/色合い   0-360度の値
	 * @param {Number} s - 彩度/鮮やかさ 0-100%の値
	 * @param {Number} v - 明度/明るさ   0-100%の値 ※v は b(Brightness)と同様
	 */
	static hsv2rgb(h,s,v){
		// var max = v;
		// var min = max - ((s / 255) * max);
		var rgb = {'r':0,'g':0,'b':0};

		if (h == 360){
			h = 0;
		}

		s = s / 100;
		v = v / 100;

		if (s == 0){
			rgb.r = v * 255;
			rgb.g = v * 255;
			rgb.b = v * 255;
			return rgb;
		}

		var dh = Math.floor(h / 60);
		var p = v * (1 - s);
		var q = v * (1 - s * (h / 60 - dh));
		var t = v * (1 - s * (1 - (h / 60 - dh)));

		switch (dh){
			case 0 : rgb.r = v; rgb.g = t; rgb.b = p;  break;
			case 1 : rgb.r = q; rgb.g = v; rgb.b = p;  break;
			case 2 : rgb.r = p; rgb.g = v; rgb.b = t;  break;
			case 3 : rgb.r = p; rgb.g = q; rgb.b = v;  break;
			case 4 : rgb.r = t; rgb.g = p; rgb.b = v;  break;
			case 5 : rgb.r = v; rgb.g = p; rgb.b = q;  break
		}

		rgb.r =  Math.round(rgb.r * 255);
		rgb.g =  Math.round(rgb.g * 255);
		rgb.b =  Math.round(rgb.b * 255);
		return rgb;
	}

	/**
	 * RGBを#がついたHEX文字列に変換する
	 * @param {Array} rgb - rgb配列[r,g,b]
	 */
	static rgb2hex(rgb){
		return "#" + rgb.map( function ( value ) {
			return ( "0" + value.toString( 16 ) ).slice( -2 ) ;
		} ).join( "" ) ;
	}

	static createHslRgb(){
		//グラデーションrgbを作成

		let start = 240
		let end = 0
		let sabun = start - end
		let rgbs = []
		for(let i=0;i<=100;i++){
			let h360 = parseInt(start - (sabun * i/100))
			let rgb = Util.hsv2rgb(h360, 60, 96)
			console.log(h360);
			rgbs.push({
				obj:rgb,
				hex:Util.rgb2hex([rgb.r,rgb.g,rgb.b])
			})
		}
		let hex = ''
		for(let i in rgbs){

			if(i != 0){
				hex += ','
			}
			hex += "'" + rgbs[i].hex + "'"
		}
		console.log(hex);

	}


	/**
	 * DATEををyyyy/mmに変換する
	 * @param {Date} date
	 */
	static dateToYYYYMM(date){
		if(date && typeof date === 'object'){
			return date.getFullYear() + '/' + Util.addZeroLeft(date.getMonth() + 1)
		}
		return ''
	}

	/**
	 * DATEををyyyy/mm/dd〜ddに変換する
	 * @param {Date} date
	 */
	static dateToYYYYMM_DD_DD(dateFrom,dateTo){
		if(dateFrom && typeof dateFrom === 'object' && dateTo && typeof dateTo === 'object'){
			return dateFrom.getFullYear() + '/' + Util.addZeroLeft(dateFrom.getMonth() + 1) + '/'  + Util.addZeroLeft(dateFrom.getDate()) + '〜'  + Util.addZeroLeft(dateTo.getDate())
		}
		return ''
	}


	/**
	 * DATEををyyyy/mmに変換する
	 * @param {Date} date
	 */
	static dateToYYYYMMHHMM(date){
		if(date && typeof date === 'object'){
			return date.getFullYear() + '/' + Util.addZeroLeft(date.getMonth() + 1) + '/' +  Util.addZeroLeft(date.getDate()) + ' ' +  Util.addZeroLeft(date.getHours()) + ':' +  Util.addZeroLeft(date.getMinutes())
		}
		return ''
	}

	/**
	 * 指定秒処理を止める
	 * @param {Number} msec
	 */
	static sleep(msec){
		return new Promise(resolve => setTimeout(resolve, msec))
	}
	
	constructor(){
	}
}

